import React from "react";

export default function AppPageTitle({ title, subtitle }) {
	return (
		<div className="mb-4 flex flex-wrap items-center gap-2 print:hidden">
			<h4 className="m-0 text-lg font-semibold text-default-900 dark:text-default-50">
				{title}
			</h4>
			{subtitle && (
				<div className="hidden items-center gap-2 text-sm font-semibold md:flex">
					<span className="text-default-500">/</span>
					<span className="font-medium text-default-700 dark:text-default-300">
						{subtitle}
					</span>
				</div>
			)}
		</div>
	);
}
